"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  shared: {
    preload: true,
    volume: 0.5
  },
  players: {}
};